import { useQuery } from "@tanstack/react-query";

import { useStore } from "@nanostores/react";
import { swaggerAxiosInstance as api } from "@vega-api/configs/customInstance";
import { $organizationId } from "@vega-api/custom/stores/organisations.store";
import { type UserPermissionEntry } from "@vega-api/generated/types/userPermissionEntry";
import {
  getGetProfileQueryKey,
  useGetProfile,
} from "@vega-api/generated/user-management-v1/user-management-v1";

export const authHook = () => console.log("example");

export const useUserProfile = () => {
  const organizationId = useStore($organizationId);

  return useGetProfile({
    query: {
      queryKey: [...getGetProfileQueryKey(), organizationId],
      refetchOnWindowFocus: false,
      select: (response) => response.data,
    },
  });
};

export const AuthService = {
  getPermissionsByUserId: async (
    userId: string,
  ): Promise<UserPermissionEntry[]> =>
    await api
      .get(`/authentication/permissions/${userId}/all`)
      .then((res) => res.data.entries),
};

export const useGetPermissionsByUserId = (userId: string) =>
  useQuery({
    queryKey: ["permissions", userId],
    queryFn: () => AuthService.getPermissionsByUserId(userId),
    enabled: !!userId,
  });
